import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { getStatus } from "../features/user/userSlice";

const PublicRoute = () => {
  const isLoggedIn = useSelector(getStatus);
  return !isLoggedIn ? <Outlet /> : <Navigate to="/" />;
};

export default PublicRoute;
